// @ts-strict-ignore
import type { Entity } from '~/entities/types';

const getEntityBusinessName = (entity: Entity, entityPII) => {
  const {
    entity_token: entityToken,
    entity_name: entityName,
  } = entity;
  const {
    businessName,
    businessAlternateName,
  } = entityPII || {};

  return businessName || businessAlternateName || entityName || `entity ${entityToken}`;
};

const getEntityPersonName = (entity: Entity, entityPII) => {
  const {
    entity_token: entityToken,
    entity_name: entityName,
  } = entity;
  const {
    nameFirst,
    nameMiddle,
    nameLast,
  } = entityPII || {};

  if (!(nameFirst || nameLast || nameMiddle)) {
    return entityName || `entity ${entityToken}`;
  }

  const names = [];
  if (nameFirst) names.push(nameFirst);
  if (nameMiddle) names.push(nameMiddle);
  if (nameLast) names.push(nameLast);
  return names.join(' ');
};

export const getEntityName = (entity: Entity, entityPII) => {
  if (!entity) return '';
  return entity.type === 'person'
    ? getEntityPersonName(entity, entityPII)
    : getEntityBusinessName(entity, entityPII);
};
